import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import OnsiteNotificationsDropdown from './onsite-notifications-dropdown';
import OnsiteNotificationsIcon from './onsite-notifications-icon';
import OnsiteNotificationsList from './onsite-notifications-list';
import { Desktop } from './breakpoints';
import onsiteNotificationCollection from '../models/onsite-notification-collection';
import { connectWebsocket } from '../actions/websocket';
import request from 'superagent';
import bugsnag from '@99designs/utils/platform/bugsnag';

export default class OnsiteNotifications extends React.Component {
    constructor(props) {
        super(props);

        this.outerNode = null;
        this.fetchNotificationsWithDebounceFunc = null;

        this.state = {
            isActive: false,
            isLoading: true,
            notifications: [],
            unreadCount: 0,
            viewportHeightDiff: null,
        };

        this.handleIconClick = this.handleIconClick.bind(this);
        this.handleIconMouseEnter = this.handleIconMouseEnter.bind(this);
        this.onMarkAllRead = this.onMarkAllRead.bind(this);
        this.onViewportHeightAdjustment = this.onViewportHeightAdjustment.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
    }

    componentWillMount() {
        this.fetchNotificationsWithDebounceFunc = debounce(this.fetchNotifications, 1000, {
            leading: true,
            maxWait: 1500,
        });

        connectWebsocket(this.props.urls.notificationsWebsocketAuth, data => {
            if (data.type) {
                if (data.type === 'unread-counter') {
                    this.setState(() => ({ unreadCount: data.count }));
                }
            }
        });
    }

    onDocumentClick(e) {
        if (this.outerNode && !this.outerNode.contains(e.target)) {
            this.deactivate();
        }
    }

    // Flag (pre-emptively) all notifications as read. We do not re-fetch from the server
    // as that would re-order/mutate the result set the user is viewing.
    // TODO handle api route failure
    onMarkAllRead() {
        const readNotifications = this.state.notifications.map(notification =>
            Object.assign({}, notification, { isRead: true })
        );
        this.setState(() => ({ notifications: readNotifications }));

        return request.post(this.props.urls.xhrMarkAllRead).end();
    }

    fetchNotifications() {
        this.setState({ isLoading: true });

        return request.get(this.props.urls.xhrFetchNotifications).then(resp => {
            const notifications = onsiteNotificationCollection.fromJSON(resp.body);
            if (!notifications) {
                bugsnag.notify(
                    'GlobalnavMissingNotifications',
                    'Globalnav failed to fetch a valid notifications array.',
                    {
                        responseStatus: resp.status,
                        responseError: resp.error,
                        responseText: resp.text,
                    }
                );
            }

            this.setState(() => ({
                isLoading: false,
                notifications: notifications,
            }));
        });
    }

    markReadCounter() {
        return request.post(this.props.urls.xhrMarkReadCounter).end();
    }

    handleIconClick(e) {
        e.preventDefault();

        this.setState((prevState, props) => ({
            isActive: !prevState.isActive,
            viewportHeightDiff: prevState.isActive ? null : prevState.viewportHeightDiff,
        }));

        this.markReadCounter();
    }

    handleIconMouseEnter() {
        if (!this.state.isActive) {
            this.fetchNotificationsWithDebounceFunc();
        }
    }

    deactivate() {
        this.setState(() => ({
            isActive: false,
            viewportHeightDiff: null,
        }));
    }

    onViewportHeightAdjustment(viewportHeightDiff) {
        this.setState({ viewportHeightDiff: viewportHeightDiff });
    }

    icon() {
        return (
            <Desktop values={this.props.desktopUiValues}>
                {isDesktopUI => {
                    if (isDesktopUI) {
                        return (
                            <OnsiteNotificationsIcon
                                urls={this.props.urls}
                                onClick={this.handleIconClick}
                                onMouseEnter={this.handleIconMouseEnter}
                                unreadCount={this.state.unreadCount}
                            />
                        );
                    } else {
                        return (
                            <OnsiteNotificationsIcon
                                urls={this.props.urls}
                                unreadCount={this.state.unreadCount}
                            />
                        );
                    }
                }}
            </Desktop>
        );
    }

    dropdown() {
        if (!this.state.isActive) {
            return null;
        }

        return (
            <OnsiteNotificationsDropdown
                onViewportHeightAdjustment={this.onViewportHeightAdjustment}
                onDocumentClick={this.onDocumentClick}
            >
                <OnsiteNotificationsList
                    notifications={this.state.notifications}
                    urls={this.props.urls}
                    onMarkAllRead={this.onMarkAllRead}
                    viewportHeightDiff={this.state.viewportHeightDiff}
                    isLoading={this.state.isLoading}
                />
            </OnsiteNotificationsDropdown>
        );
    }

    render() {
        return (
            <div className="onsite-notifications" ref={node => (this.outerNode = node)}>
                {this.icon()}
                {this.dropdown()}
            </div>
        );
    }
}

OnsiteNotifications.propTypes = {
    urls: PropTypes.object.isRequired,
    desktopUiValues: PropTypes.object,
};

OnsiteNotifications.defaultProps = {
    desktopUiValues: {},
};



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/components/onsite-notifications.jsx